import { useWorkspaceStore } from '@editor/stores/workspaceStore';
import { KittlHeaderNames } from '@repo/api-client';

/**
 * Set the workspace that should be used for asset related tasks
 * (this is different to the design workspace because we could be an external editor)
 * note: design workspace header is added automatically if a WORKSPACE_ID header is not present
 *
 * @returns a map of headers or undefined if the workspace is not set
 */
export const getAssetWorkspaceHeaders = (): {
  [KittlHeaderNames.WORKSPACE_ID]?: string;
} => {
  const assetsWorkspace = useWorkspaceStore.getState().workspaceForAssets;
  if (!assetsWorkspace) {
    return {};
  }
  return {
    // because our permissions might not allow us to use assets from the design workspace
    // we need to use the workspace of the assets
    [KittlHeaderNames.WORKSPACE_ID]: assetsWorkspace,
  };
};
